import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { CountryType } from '../../../model';
import { SiteConnector } from '../../../site-context/connectors';
import { normalizeHttpError } from '../../../util';
import { UserActions } from '../actions';
import { OnboardingCountriesActionTypes } from '../actions/onboarding-countries.action';

@Injectable()
export class OnboardingCountriesEffects {
  loadOnboardingCountries$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OnboardingCountriesActionTypes.LoadOnboardingCountries),
      exhaustMap((action: UserActions.LoadOnboardingCountries) => {
        // https://stackoverflow.com/questions/61225575/spartacus-extend-or-override-the-pagetype-enum-from-cms-model
        // const type = CountryType.ONBOARDING as CountryType; // TOTO ESVCX-7451
        return this.connector.getCountriesByType(action.userId, 'ONBOARDING' as CountryType).pipe(
          map((countries) => new UserActions.LoadOnboardingCountriesSuccess(countries)),
          catchError((error) => of(new UserActions.LoadOnboardingCountriesFail(normalizeHttpError(error))))
        );
      })
    )
  );

  constructor(private actions$: Actions, private connector: SiteConnector) {}
}
